import { createTagsGrpcBridge } from './tags';
import { createEventsGrpcBridge } from './events/events';
import { createSegmentsGrpcBridge, } from './segments/segments';
import { createEmailTemplatesGrpcBridge, } from './emailTemplates/emailTemplates';
function applyLoggingProxy(bridgeMethods, getEnableLogging) {
    let count = 0;
    return Object.keys(bridgeMethods).reduce((acc, namespace) => {
        acc[namespace] = Object.keys(bridgeMethods[namespace]).reduce((acc2, method) => {
            acc2[method] = async (args) => {
                const startTime = Date.now();
                const id = count++;
                if (getEnableLogging()) {
                    console.log(`grpc #${id} call: ${namespace}.${method}`, args);
                }
                try {
                    const result = await bridgeMethods[namespace][method](args);
                    if (getEnableLogging()) {
                        console.log(`grpc #${id} result: ${namespace}.${method} ${Date.now() - startTime}ms`, result);
                    }
                    return result;
                }
                catch (error) {
                    console.log(`grpc #${id} error: ${namespace}.${method} ${Date.now() - startTime}ms`, error);
                    throw error;
                }
            };
            return acc2;
        }, {});
        return acc;
    }, {});
}
export function createGrpcBridge(grpcClient) {
    let enableLogging = false;
    const getEnableLogging = () => enableLogging;
    const proxied = applyLoggingProxy({
        tags: createTagsGrpcBridge(grpcClient),
        events: createEventsGrpcBridge(grpcClient),
        segments: createSegmentsGrpcBridge(grpcClient),
        emailTemplates: createEmailTemplatesGrpcBridge(grpcClient),
    }, getEnableLogging);
    return {
        setEnableLogging: (enable) => {
            enableLogging = enable;
        },
        ...proxied,
    };
}
